import httpClient from '@api/httpClient'
import type { PaginatedResponse } from '@models/pagination'
import type {
  AddOperationParams,
  FinanceFilters,
  FinanceOperation,
} from '@models/finance'
import { financesUrls } from './constants'

const getFinances = async (filters?: FinanceFilters) => {
  const { data } = await httpClient.get<PaginatedResponse<FinanceOperation>>(
    financesUrls.list(filters),
    { params: filters },
  )

  return data
}

const addOperation = async (data: AddOperationParams) =>
  httpClient.post<FinanceOperation[]>(financesUrls.addFinances, data)

export default {
  getFinances,
  addOperation,
}
